import {
  CreateOrderAccessory,
  CreateOrderFlowDetails,
  CreateOrderRequest,
  FlowType
} from '@detox/actions';
import { Plan } from '../types/plan.types';
import { SkuVariant } from '../types/product.types';
import { SelectedAccessory } from '../types/accessory.types';
import isSimOnlyPlan from './is-sim-only-plan';
import ORDER_CONSTANT from '../constants/order';

export type GetEshopCreateOrderParams = {
  selectedPlan: Plan;
  selectedProduct: SkuVariant;
  selectedAccessories: SelectedAccessory[];
  cisToken?: string;
  captchaToken?: string;
  simType?: 'eSIM' | 'physicalSIM';
  orderType: string;
  newNumber?: string;
  reconServiceId?: string;
  reconServiceNumber?: string;
};
export const getEshopCreateOrderParams = (
  params: GetEshopCreateOrderParams
): Partial<CreateOrderRequest> => {
  const {
    selectedProduct,
    selectedPlan,
    selectedAccessories = [],
    orderType
  } = params;
  const accessories: CreateOrderAccessory[] = selectedAccessories.map(
    accessory => {
      return { accessoryId: accessory.deviceCode };
    }
  );

  return {
    hasBackOrder: selectedProduct?.isBackOrder,
    accessories,
    flowType: getFlowType({ orderType, selectedPlan }),
    flowDetails: getFlowDetail(params)
  };
};

const getFlowDetail = ({
  simType,
  cisToken,
  selectedProduct,
  selectedPlan,
  captchaToken,
  newNumber,
  reconServiceId,
  reconServiceNumber
}: Partial<GetEshopCreateOrderParams>): CreateOrderFlowDetails => {
  return {
    simType,
    recontractProductId: reconServiceId,
    cisToken,
    serviceId: {
      msisdn: reconServiceNumber || newNumber,
      captchaToken
    },
    product: {
      deviceId: selectedProduct?.deviceCode
    },
    plan: {
      planId: selectedPlan.planId
    }
  };
};

const getFlowType = ({
  orderType,
  selectedPlan
}: Partial<GetEshopCreateOrderParams>): FlowType => {
  const isSimOnly = isSimOnlyPlan(selectedPlan);
  const isMSNew = orderType === ORDER_CONSTANT.TYPE.MS_NEW;
  const isMSRecon = orderType === ORDER_CONSTANT.TYPE.MS_RECONTRACT;
  const isPortIn = orderType === ORDER_CONSTANT.TYPE.PORTIN;
  const isNew = orderType === ORDER_CONSTANT.TYPE.NEW;
  const isRecon = orderType === ORDER_CONSTANT.TYPE.RECON;

  switch (true) {
    case isMSNew:
      return 'mobileShareNew';
    case isMSRecon:
      return 'mobileShareRecon';
    case isSimOnly && isRecon:
      return 'simOnlyRecon';
    case isSimOnly && isNew:
      return 'simOnlyNew';
    case isSimOnly && isPortIn:
      return 'simOnlyPortIn';
    case isRecon:
      return 'phonePlanRecon';
    case isNew:
      return 'phonePlanNew';
    case isPortIn:
      return 'phonePlanPortIn';
  }
};
